import React, {useCallback, useState} from "react";
import {Box, Button, Modal, Stack, TextField, Typography,} from "@mui/material";
import PhoneInput from "react-phone-number-input";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalMatchCard({
                                           id,
                                           open,
                                           handleClose,
                                           handleSubmit,
                                           isBirthdayDisabled
                                       }) {
    const [phone, setPhone] = useState("");
    const [birthDate, setBirthDate] = useState("");

    const handleFormSubmit = useCallback(
        (e) => {
            e.preventDefault();
            handleSubmit(id, phone?.replace('+7', '8'), birthDate);
            handleClose();
        },
        [birthDate, phone, id, handleSubmit, handleClose]
    );

    const handleChange = (value) => {
        if (value && value.startsWith('8')) {
            setPhone('+7' + value.slice(1)); // Преобразуем 8 в +7
        } else {
            setPhone(value);
        }
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Сопоставить с картой
                </Typography>
                <form onSubmit={handleFormSubmit}>
                    <Stack spacing={2}>
                        <PhoneInput
                            placeholder="Введите номер телефона"
                            value={phone}
                            onChange={handleChange}
                            defaultCountry="RU" // Указываем Россию как единственную страну
                            international={false} // Отключаем международный формат
                            countrySelectProps={{disabled: true}} // Блокируем выбор страны
                            countryOptions={['RU']} // Ограничиваем выбор только Россией
                            displayInitialValueAsLocalNumber={true}
                        />
                        {
                            !isBirthdayDisabled && (
                                <TextField
                                    label="Дата рождения"
                                    type="date"
                                    InputLabelProps={{shrink: true}}
                                    value={birthDate}
                                    onChange={(e) => setBirthDate(e.target.value)}
                                    fullWidth
                                />
                            )
                        }
                        <Button type="submit" variant="contained">
                            Подтвердить
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Modal>
    );
}
